// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"c820ea98","140":"c2f0ea47","224":"aa1a220b","429":"06315337","502":"ed3ff7e6","580":"81ed92f4","680":"713cd73c","744":"d225079a","745":"fe53b63e","967":"32b5dfe0"}[chunkId] + ".chunk.css";
};